import Vue from "vue";
import Vuex from "vuex";
import User from "@/store/modules/user.store";
import App from "@/store/modules/app.store";
import Customers from "@/store/modules/customers.store";
import Tags from "@/store/modules/tags.store";
import Addresses from "@/store/modules/addresses.store";
import Orders from "@/store/modules/orders.store";
import Business from "@/store/modules/business.store";
import Drivers from "@/store/modules/drivers.store";
import Units from "@/store/modules/units.store";
import Teams from "@/store/modules/teams.store";
import Locations from "@/store/modules/location.store";
import Categories from "@/store/modules/categories.store";
import Dashboard from "@/store/modules/dashboard.store";
import SaleOptions from "@/store/modules/sales-options.store";
// @ts-ignore
import Delivery from "@/store/modules/delivery.store";
import OOCStore from "@/store/modules/ooc";
import DigitalMenu from "@/store/modules/digital-menu.store";

Vue.use(Vuex);

/**
 * Combine store
 * @example this.$store.state
 */
export default new Vuex.Store({
  modules: {
    User,
    App,
    Customers,
    Orders,
    Addresses,
    Tags,
    Business,
    Drivers,
    Units,
    Categories,
    // @ts-ignore
    Locations,
    SaleOptions,
    Dashboard,
    Delivery,
    OOCStore,
    Teams,
    DigitalMenu
  },
});
